import HealthInfoDetail from "./HealthInfoDetail";
import { HealthStatusType } from "./HealthStatusType";

export default class HealthInfoService
{
    constructor(currentUpdate, lastProblemUpdate)
    {
       this.currentUpdate = currentUpdate || new HealthInfoDetail();
       this.lastProblemUpdate = lastProblemUpdate || null;  
    }

    overallStatus()
    {
        var testOk = this.currentUpdate.updateStatus == HealthStatusType.OK;
        var hasCurrentError = (this.currentUpdate?.updateStatus != HealthStatusType.OK) 
        var hasPreviousError =  (this.lastProblemUpdate) && ((this.lastProblemUpdate?.updateStatus != HealthStatusType.OK))

        if (hasCurrentError) return HealthStatusType.ERROR;
        if (hasPreviousError) return HealthStatusType.WARNING;
        return HealthStatusType.OK;
        
    }


}
